import { SelectedData } from 'types/common/FormTypes';
import { SelectOptions } from 'types/productTypes';
import { StoreCodes, StoreInfo, StoresText } from 'types/store/StoreTypes';

export const convertToStoresInfoToBranchOptions = async (
  data: StoreInfo[] | []
): Promise<SelectOptions[]> => {
  if (!data || data.length === 0) {
    return [{ options: [] }];
  }
  return [
    {
      options: data.map((item) => ({
        label: item.name,
        value: item.id.toString(),
      })),
    },
  ];
};

export const convertToStoresInfoToBranchOptions2 = async (
  data: StoreInfo[] | [],
  test = 0
): Promise<SelectedData[]> => {
  if (!data || data.length === 0) {
    return [];
  }
  const branchOptions = data.map((item) => ({
    label: item.name_with_code,
    value: item.id.toString(),
  }));

  if (test === 1) {
    branchOptions.unshift({ label: 'Test 4', value: '4' });
    branchOptions.unshift({ label: 'Test 3', value: '3' });
    branchOptions.unshift({ label: 'Test 2', value: '2' });
    branchOptions.unshift({ label: 'Test 1', value: '1' });
  }

  return branchOptions;
};
export const convertStoresInfoToBrachCode = async (
  data: StoreInfo[] | []
): Promise<StoreCodes[]> => {
  if (!data || data.length === 0) {
    return [];
  }
  const branchCodes = data.map((item) => ({
    storeId: item.id,
    code: item.code,
  }));

  return branchCodes;
};
export const convertStoresInfoToStoresText = async (
  data: StoreInfo[] | []
): Promise<StoresText[]> => {
  if (!data || data.length === 0) {
    return [];
  }
  const branchCodes = data.map((item) => ({
    storeId: item.id,
    code: item.code,
    name: item.name,
    storeText: `${item.code}:${item.name}`,
  }));

  return branchCodes;
};

export const getStoreNameByID = (
  stores: StoreInfo[],
  id: number
): string | undefined => {
  const store = stores.find((store) => store.id === id);
  return store?.name;
};
